<div [attr.id]="id + '-lib-accordion-subheader'" class="js-fmc-accordion fmc-accordion bootstrapped" [ngClass]="{
  'fds-color__bg--light': background === 'light',
  'fds-color__bg--dark': background === 'dark',
  'fmc-accordion--light': foreground === 'light',
  'accordion-last-element': lastElementInThePage
}">
  <div class="fmc-accordion__panel" [ngClass]="{'fmc-accordion--active': active, 'fmc-accordion--expanded': expanded}">
    <h3>
      <button class="fmc-accordion__button" [attr.id]="id + '-lib-accordion-subheader-button'" aria-controls="panel-1-content"
        [attr.aria-expanded]="state === 'closed' || state === 'closing' ? false : true"
        [attr.aria-hidden]="state === 'closed' || state === 'closing' ? true : false" (click)="toggle()"
        (blur)="onBlur()">
        <span class="fmc-accordion__button-text">
          <span class="header">
            @if (headerIcon) {
              <span class="icon">
                <img width="45" [src]="'./assets/images/icons/' + headerIcon" alt="">
              </span>
            }
            {{ header }}
          </span>
          <span class="subheader">{{ subheader }}</span>
        </span>
        <span class="fds-icon"></span>
      </button>
    </h3>
    <div class="fmc-accordion__body"
      [ngStyle]="{'height': state === 'closed' || state === 'closing' ? 0 : content.offsetHeight + 'px'}"
      (transitionend)="onTransitionEnd()">
      <div #content class="fmc-accordion__content" aria-labelledby="panel-1-button"
        [attr.id]="id + '-lib-accordion-subheader-content'" role="region" aria-hidden="false" [ngClass]="{'bg-white': smallContent}"
        [ngStyle]="{'visibility': state === 'closed' ? 'hidden' : 'visible'}">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</div>